<template>
  <section class="w-full p-6">
    <h1 v-if="!trabalho" class="text-xl font-bold text-gray-900 mb-5">
      Para prosseguir com a avaliação, informe a mesa
    </h1>
    <div v-if="!trabalho">
      <label class="block text-sm font-medium text-gray-900">Mesa</label>
      <input type="text"
             v-model="mesa"
             name="email" class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5" placeholder="Número da mesa">
    </div>
    <button v-if="!trabalho" @click="buscaTrabalho" type="button" class="w-full mt-3 text-white bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Buscar</button>

    <form v-if="trabalho" @submit.prevent>
      <div class="flex justify-between items-center mb-2">
        <span>Mesa: <b>{{trabalho.mesa}}</b></span>
        <button type="button" class="text-white bg-amber-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center" @click="trocarMesa">Trocar mesa</button>
      </div>

      <div class="mt-2 mb-6">
        <p class="mb-2">Trabalho: <b v-text="trabalho.nome"></b></p>
        <p class="mb-4">Orientador: <b v-text="trabalho.orientador.nome"></b></p>
        <p>Alunos:</p>
        <p class="mt-1 fs-1 pl-4" v-for="aluno in trabalho.alunos" v-text="aluno.nome"></p>
      </div>

      <div v-if="cpfInvalido" class="p-4 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
        <span class="font-medium">CPF Inválido!</span> Informe um CPF válido para prosseguir.
      </div>

      <div v-if="jaVotou" class="p-4 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
        <span class="font-medium">Você já votou!</span> Obrigado, seu voto já consta em nosso sistema.
      </div>

      <div v-if="sucesso" class="p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg" role="alert">
        <span class="font-medium">Obrigado!</span> Obrigado, sua participação é importante.
      </div>

      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-900 mb-2">Informe seu CPF</label>
        <input type="text"
               v-model="form.cpf"
               class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5">
      </div>

      <button type="button"
              @click="avalia"
              :disabled="!form.cpf"
              class="disabled:bg-gray-300 w-full text-white bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Confirma voto</button>
    </form>
  </section>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import { ref } from "vue"
import axios from "axios";

export default {
  name: "AvaliarMesa",
  data: () => {
    return {
      trabalho: null,
      mesa: null,
      jaVotou: false,
      cpfInvalido: false,
      sucesso: false,
    }
  },
  setup() {
    const form = useForm({
      id: null,
      cpf: null
    })

    return {
      form
    }
  },
  methods: {
    buscaTrabalho() {
      axios.get(route('mobile.visitante.busca-trabalho', this.mesa)).then( response => {
        this.trabalho = response.data
        this.form.id = this.trabalho.id
      })
    },
    avalia() {
      console.log(this.form.cpf)
      axios.post(route('mobile.visitante.avaliar-mesa-store'), this.form.data()).then( response => {
        this.cpfInvalido = false
        this.jaVotou = false

        if (response.status === 202) {
          this.cpfInvalido = true
          return
        }

        if (response.status === 203) {
          this.jaVotou = true
          return
        }

        this.sucesso = true

        setTimeout(() => {
          this.sucesso = false
          location.reload()
        }, 2000)
      })
    },
  }
}
</script>

<style scoped>

</style>
